module.exports = __webpack_public_path__ + "static/img/articlework.8990cbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articlework.jpg
// module id = gZ6Z
// module chunks = 1